import React, {Component} from 'react';
import axios from "axios";
import './ReservationConfirmationPage.css';


class ReservationConfirmationPage extends Component {

    formSubmit = (event) => {
        event.preventDefault();

        let reservationId = this.props.location.pathname.split("/");

        const data = {
            confirmationCode: event.target.confirmationCode.value
        };

        axios.post('/api/hotels/' + reservationId[2] + '/confirm', data)
            .then(() => {
                this.props.history.push('/');
            })
            .catch((error) => {
                console.log(error);
            });
    };

    render() {
        const bgStyle = {
            backgroundImage: "url('/assets/img/wallpaper-tumblr-pc-awesome-yukle-1200x851-travel-background-tumblr-pc-most-beautiful-of-wallpaper-tumblr-pc.jpg')",
            marginTop: "-20px",
            backgroundSize: "cover",
            backgroundPosition: "top center"
        };
        return (
            <div className="page-header header-filter"
                 style={bgStyle}>
                <div className="container">
                    <div className="row">
                        <div className="col-lg-6 col-md-6 ml-auto mr-auto">
                            <div className="card card-confirm">
                                <form className="form" onSubmit={this.formSubmit}>

                                    <h3 className="card-title">Room reservation confirmation</h3>

                                    <div className="card-body">
                                        <div className="bmd-form-group">
                                            <div className="input-group">
                                                <input
                                                    className="form-control"
                                                    name="confirmationCode"
                                                    type="text"
                                                    placeholder="Confirmation code"
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <button className="btn btn-primary my-buttons" type="submit">confirm</button>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default ReservationConfirmationPage;



// WEBPACK FOOTER //
// ./src/containers/Confirmation/ReservationConfirmationPage.jsx